import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { MdDialog, MdDialogConfig, MdDialogRef } from '@angular/material';
import { plainToClass } from 'class-transformer';
import { RuleGroup } from './../rule-group.model';
import { RuleManagementService } from './../rule-management.service';
import { MessageService } from './../../../services/messages.service';
import { SnackBarService } from './../../../services/snackbar.service';
import { TrackingService } from '../../../shared/services/tracking/google-analytics-events.service';
import { TrackingConstants } from './../../../shared/services/tracking/tracking-constants.service';
import { AddRuleGroupComponent } from '../addrulegroup/add-rulegroup.component';

@Component({
    selector: 'rulegroup-list',
    templateUrl: './rulegroup-list.component.html',
    styleUrls: ['./rulegroup-list.component.css']
})

/**
 * Component for display the rule group list.
 *
 * @author pankaj.khurana@vernuso.com (Pankaj Khurana)
 */
export class RuleGroupListComponent implements OnInit {
    rulegroup: RuleGroup[];
    dialogRef: MdDialogRef<any>;
    selectedRuleGroup: RuleGroup;
    isLoading = true;

    constructor(
        public dialog: MdDialog,
        public viewContainerRef: ViewContainerRef,
        private ruleManagementService: RuleManagementService,
        private trackingService: TrackingService,
        private snackBarService: SnackBarService,
    ) { }

    ngOnInit() {
        this.getRuleGroupList();
    }

    getRuleGroupList() {
        this.ruleManagementService.getRuleGroup()
            .subscribe(response => {
                this.rulegroup = response;
                this.isLoading = false;
            });
    }

    openAddRuleGroupDialog(action: string) {
        let config = new MdDialogConfig();
        config.viewContainerRef = this.viewContainerRef;
        this.dialogRef = this.dialog.open(AddRuleGroupComponent, config);
        this.dialogRef.componentInstance.selectedRuleGroup = this.selectedRuleGroup;
        this.dialogRef.componentInstance.action = action;
        this.dialogRef.afterClosed().subscribe(result => {
            this.dialogRef = null;
            if (result) {
                this.updateRuleGroupList(result, action);
            }
            this.selectedRuleGroup = null;
        });
    }

    updateRuleGroupList(formResponse: RuleGroup, action: string) {
        if (action === 'Edit') {
            this.rulegroup.splice(this.rulegroup.indexOf(this.selectedRuleGroup), 1);
        }
        this.rulegroup.unshift(formResponse);
    }

    editRuleGroup(value: RuleGroup): void {
        this.selectedRuleGroup = value
        this.openAddRuleGroupDialog('Edit');
    }

    deleteRuleGroup(rulegroup: RuleGroup): void {
        if (confirm(MessageService.DELETE_RULE_GROUP_ALERT)) {
            this.ruleManagementService.deleteRuleGroup(rulegroup.groupId)
                .subscribe(response => {
                    if (response.flagResult) {
                        this.rulegroup.splice(this.rulegroup.indexOf(rulegroup), 1);
                    }
                    this.trackingService
                        .emitEvent(
                        TrackingConstants.RULE_MANAGEMENT,
                        TrackingConstants.DELETE_RULE_GROUP,
                        TrackingConstants.SUCCESS, 1);
                    this.callSnackBarService(response,
                        MessageService.DELETE_RULE_GROUP_SUCCESS, MessageService.DELETE_RULE_GROUP_FAILURE);
                },
                err => {
                    this.trackingService
                        .emitEvent(
                        TrackingConstants.RULE_MANAGEMENT,
                        TrackingConstants.DELETE_RULE_GROUP,
                        TrackingConstants.FAILURE, 0);
                    this.callSnackBarService(err,
                        MessageService.DELETE_RULE_GROUP_SUCCESS,
                        MessageService.DELETE_RULE_GROUP_FAILURE);
                });
        }
    }
    callSnackBarService(response: any, successMsg: string, failureMsg: string) {
        this.snackBarService.showStatus(response, successMsg, failureMsg);
    }
}



// WEBPACK FOOTER //
// ./src/app/admin/rules/rulegrouplist/rulegroup-list.component.ts